<template>
    <div v-if="show" class="overlay-blocker">
        <p>This system is unable to process your request.</p>
    </div>
</template>
<script>
export default {
  props: {
    show: Boolean
  }
};
</script>
<style scoped>
.overlay-blocker {
  position: absolute; /* important */
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  min-height: 100vh; /* ensure minimum viewport */
  background-color: black;
  color: white;
  z-index: 9999;
  font-size: 24px;

  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;

  /* this ensures text stays centered even on long pages */
  flex-direction: column;
}
</style>